import React, { FC, useCallback, useEffect, useMemo } from 'react'
import { useController, useFormContext } from 'react-hook-form'
import { InputGroup, Select } from '@wmgtech/legato'

import { cn } from 'shared/utils'
import { FormSelect } from 'components/FormWithGroup'

import { useZone } from '../../serviceHooks'
import { IUserForm } from 'modules/Users/types'

export const ZonesField: FC = () => {
  
  const { zoneOptions, getCountryOptions } = useZone()

  const {
    field: { ref, ...restField },
    fieldState: { error }
  } = useController<IUserForm, 'label_id'>({ name: 'label_id' })

  const { control, setValue, getValues } = useFormContext<IUserForm>()

  const handleChange = useCallback(
    (el) => {
      if (typeof el === 'undefined') {
        restField.onChange('')
      } else {
        restField.onChange(el.value)
      }
    },
    [restField],
  )

  const countryOptions = useMemo(
    () => getCountryOptions(restField.value),
    [getCountryOptions, restField.value],
  )

  const countryValues = useMemo(
    () => countryOptions.map(({ value }) => value),
    [countryOptions]
  )

  useEffect(
    () => {
      const currentCountryCode = getValues('country_code')
      if (countryOptions.length === 0) return
      if (typeof currentCountryCode === 'undefined' || !countryValues.includes(currentCountryCode)) {
        setValue('country_code', countryOptions[0]?.value || '')
      }
    },
    [countryOptions, countryValues, getValues, restField.value, setValue],
  )

  useEffect(
    () => {
      return () => {
        restField.onChange(undefined)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return (
    <>
      <InputGroup
        label="Zone"
        className={cn('form-input-group', { 'form-input-group__error': error })}
        labelProps={{ icon: 'asterisk' }}
        validation={{
          message: error?.message,
          ...(error && { type: 'error' })
        }}
      >
        <Select
          className="form-select"
          list={zoneOptions}
          placeholder="Select Zone"
          getKey={el => el?.value}
          getTitle={el => el?.label}
          onSelect={handleChange}
          autoComplete="off"
          inputRef={ref}
          {...restField}
        />
      </InputGroup>
      <FormSelect
        label="Default Country Code"
        placeholder="Select Code"
        fieldName="country_code"
        disabled={!restField.value}
        options={countryOptions}
        control={control}
        rules={{ required: true }}
      />
    </>
  )
}
